import { computed, ref } from 'vue'

export function useCardSearch(fields = ['card_name', 'card_id']) {
  const search = ref('')

  const normalizedTerm = computed(() => search.value.trim().toLowerCase())
  const hasSearch = computed(() => normalizedTerm.value.length > 0)

  function matchesCardSearch(card) {
    if (!hasSearch.value) return true

    return fields.some(field => {
      const rawValue = card?.[field]
      if (rawValue === undefined || rawValue === null) return false
      return String(rawValue).toLowerCase().includes(normalizedTerm.value)
    })
  }

  return {
    search,
    hasSearch,
    normalizedTerm,
    matchesCardSearch,
  }
}